import Vue from "vue";

Vue.mixin({
  computed: {
    formRules: () => ({
      required: value => !!value || "Required.",
      min: v => (!!v && v.length >= 6) || "Min 6 characters",
      email: v => /.+@.+/.test(v) || "E-mail must be valid",
      URL: v =>
        /^(tel|mailto):/.test(v) ||
        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/.test(
          v
        ) ||
        "Not a valid URL",
      YT: v =>
        /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/.test(
          v
        ) || "Not a valid YouTube url"
    }),
    fa: () => camelCasedIcon => `fas fa-${camelCaseToKebabCase(camelCasedIcon)}`
  }
});

export function camelCaseToKebabCase(string) {
  return (
    string &&
    string.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase()
  );
}
export function kebabCaseToCamel(str) {
  return str.replace(/([-_][a-z])/g, group =>
    group
      .toUpperCase()
      .replace("-", "")
      .replace("_", "")
  );
}
